import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowLeft, Mail, Clock, MessageSquare } from 'lucide-react';
import { siteConfig } from '../data';

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-emerald-950 pt-32 pb-20 flex flex-col items-center justify-center px-4 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-emerald-900/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] bg-emerald-900/20 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl w-full relative z-10">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-emerald-400/10 rounded-full mb-8 border border-emerald-400/20">
            <CheckCircle className="h-12 w-12 text-emerald-400" />
          </div>
          
          <h1 className="text-4xl md:text-7xl font-medium text-white mb-6 tracking-tight">
            Tak for din henvendelse
          </h1>
          <p className="text-xl md:text-2xl text-emerald-50/70 mb-16 max-w-2xl mx-auto leading-relaxed">
            Jeg har modtaget din besked og glæder mig til at læse den. 
            Du kan forvente at høre fra mig inden for kort tid.
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-16">
            <div className="p-8 bg-emerald-900/30 border border-emerald-800/50 backdrop-blur-sm group hover:border-emerald-500/50 transition-colors">
              <Clock className="h-8 w-8 text-emerald-400 mb-4 mx-auto" />
              <h3 className="font-bold text-white mb-2">Hurtig respons</h3>
              <p className="text-sm text-emerald-50/60 leading-relaxed">Jeg svarer typisk inden for 24 timer på hverdage.</p>
            </div>
            <div className="p-8 bg-emerald-900/30 border border-emerald-800/50 backdrop-blur-sm group hover:border-emerald-500/50 transition-colors">
              <Mail className="h-8 w-8 text-emerald-400 mb-4 mx-auto" />
              <h3 className="font-bold text-white mb-2">Bekræftelse</h3>
              <p className="text-sm text-emerald-50/60 leading-relaxed">Du modtager en bekræftelse på din oplyste e-mail adresse.</p>
            </div>
            <div className="p-8 bg-emerald-900/30 border border-emerald-800/50 backdrop-blur-sm group hover:border-emerald-500/50 transition-colors">
              <MessageSquare className="h-8 w-8 text-emerald-400 mb-4 mx-auto" />
              <h3 className="font-bold text-white mb-2">Næste skridt</h3>
              <p className="text-sm text-emerald-50/60 leading-relaxed">Vi tager en uforpligtende dialog om dine konkrete behov.</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <Link
              to="/"
              className="w-full sm:w-auto bg-white text-emerald-950 px-10 py-4 font-bold hover:bg-emerald-50 transition-all flex items-center justify-center shadow-xl"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Tilbage til forsiden
            </Link>
            <Link
              to="/referencer"
              className="w-full sm:w-auto border border-white/20 text-white px-10 py-[15px] font-bold hover:bg-white/5 transition-all flex items-center justify-center"
            >
              Se mine referencer
            </Link>
          </div>
        </div>

        {/* Support text */}
        <div className="mt-20 pt-10 border-t border-emerald-800/50 text-center">
          <p className="text-emerald-50/40 text-sm">
            Har du brug for akut hjælp? Ring direkte til mig på <span className="text-emerald-400">+45 {siteConfig.phone}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
